export default __webpack_public_path__ + "static/media/jnh6.cdbd8d54.jpg";